import React from 'react'

const sizeClassName = {
  sm: 'w-3 h-3',
  md: 'w-4 h-4',
  lg: 'w-6 h-6',
  xl: 'w-8 h-8',
  '2xl': 'w-12 h-12'
}

type TProps = {
  colorStopOffset?: number
  size?: keyof typeof sizeClassName
  customCss?: string
}

type TComponentProps = {
  className: string
  colorStopOffset?: number
}

function withIcon(Component: React.FC<TComponentProps>): React.FC<TProps> {
  return function _withIcon({
    colorStopOffset,
    size = 'md',
    customCss
  }: TProps): JSX.Element {
    return (
      <Component
        className={`shrink-0 ${customCss ?? sizeClassName[size]}`}
        colorStopOffset={colorStopOffset}
      />
    )
  }
}

export default withIcon
